import { render, staticRenderFns } from "./AsyncImport.vue?vue&type=template&id=0d6602be"
import script from "./AsyncImport.vue?vue&type=script&lang=js"
export * from "./AsyncImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebars@4.7._pgqouf3rnsspsizlpwr4yhs5p4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6602be')) {
      api.createRecord('0d6602be', component.options)
    } else {
      api.reload('0d6602be', component.options)
    }
    module.hot.accept("./AsyncImport.vue?vue&type=template&id=0d6602be", function () {
      api.rerender('0d6602be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/ui/components/asyncImport/AsyncImport.vue"
export default component.exports